module.exports = __webpack_public_path__ + "media/images/logo_color-11e9979852f7464ef0975712ae7dfeae.svg";